import React from 'react';

import i18n from '../../I18n';
import OtherInfoDatetimeField from './otherInfoFields/OtherInfoDatetimeField';
import OtherInfoDropdownField from './otherInfoFields/OtherInfoDropdownField';
import OtherInfoSelectionField from './otherInfoFields/OtherInfoSelectionField';
import OtherInfoTextField from './otherInfoFields/OtherInfoTextField';
import OtherInfoToggleField from './otherInfoFields/OtherInfoToggleField';

import { ADDITIONAL_DATA_TYPE } from 'utils/CustomEnums';

const fieldComponentMap = {
  [ADDITIONAL_DATA_TYPE.TEXT]: OtherInfoTextField,
  [ADDITIONAL_DATA_TYPE.NUMBER]: OtherInfoTextField,
  [ADDITIONAL_DATA_TYPE.DATETIME]: OtherInfoDatetimeField,
  [ADDITIONAL_DATA_TYPE.TOGGLE]: OtherInfoToggleField,
  [ADDITIONAL_DATA_TYPE.CHECKBOX]: OtherInfoToggleField,
  [ADDITIONAL_DATA_TYPE.DROPDOWN]: OtherInfoDropdownField,
  [ADDITIONAL_DATA_TYPE.SINGLE_CHOICES]: OtherInfoSelectionField,
  [ADDITIONAL_DATA_TYPE.MULTI_CHOICES]: OtherInfoSelectionField,
};

const QuestionSection = ({ language, question, isConfirm, editAction }) => {
  const questionFormat = question.questionFormat || ADDITIONAL_DATA_TYPE.TEXT;
  const FieldComponent = fieldComponentMap[questionFormat];

  return (
    <FieldComponent
      language={language}
      question={question}
      isConfirm={isConfirm}
      editAction={editAction}
    />
  );
};

const SingleQuestion = ({ language, question = {}, isConfirm, editAction }) => (
  <div>
    <div>
      <label className="ticket_question_title body-2">
        {question.title}{' '}
        {question.optional ? i18n.t('personal_info_optional') : null}
      </label>
    </div>

    <QuestionSection
      language={language}
      question={question}
      isConfirm={isConfirm}
      editAction={editAction}
    />
  </div>
);

const OtherInfoSection = ({
  language,
  showOtherInfo,
  questionData,
  setQuestionData,
  isConfirm,
}) => {
  console.log('@@questionData:', questionData);

  const editAction = (fieldName, value) => {
    setQuestionData((previousData) =>
      (previousData || [])?.map((item) => {
        if (item.fieldName === fieldName) {
          item.defaultValue = value;
        }
        return item;
      }),
    );
  };

  if (!showOtherInfo || !questionData?.length) {
    return null;
  }

  return (
    <div className="ticket_other_info_container">
      <div>
        <label className="ticket_other_info_title headline">
          {i18n.t('otherInformation')}
        </label>
      </div>
      <div>
        {questionData?.map((question, index) => (
          <SingleQuestion
            language={language}
            key={`question-${question?.title}`}
            question={question}
            isConfirm={isConfirm}
            editAction={editAction}
          />
        ))}
      </div>
    </div>
  );
};

export default OtherInfoSection;
